import { flags } from '@microsoft/portal-app/lib/feature-flags';

export interface IAccountFlags {
  signIns: boolean;
  securityInfo: boolean;
}

export const registerAccountFlags = () =>
  flags.registerFlags<IAccountFlags>({
    signIns: 'signIns',
    securityInfo: 'securityInfo'
  });
